import RadioTile from '@liquidweb-dev/undercurrent/RadioTile';
import SparklesIcon from '@liquidweb-dev/undercurrent/icons/lucide/Sparkles';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';

interface BackupOption {
	label: string;
	value?: string;
	icon?: React.ReactNode;
	description: string;
	checked?: boolean;
	/** Marks the tile with the green "Recommended" chip. */
	isRecommended?: boolean;
}

/** The green "Recommended" chip shown above a recommended tile's title. */
const RecommendedChip = () => (
	<Stack
		direction="row"
		sx={{
			alignItems: 'center',
			gap: 50,
		}}
	>
		<SparklesIcon
			sx={({ size, vars }) => ({
				color: vars.palette.uc.success.icon.main,
				height: size.xS,
				width: size.xS,
			})}
		/>
		<Typography
			variant="label-lg"
			sx={({ vars }) => ({
				color: vars.palette.uc.success.text.main,
				fontWeight: 500,
			})}
		>
			Recommended
		</Typography>
	</Stack>
);

const BackupTile = ({
	label,
	value,
	description,
	icon,
	checked = false,
	isRecommended = false,
	...rest
}: BackupOption & React.ComponentProps<typeof RadioTile>) => (
	<RadioTile key={value} value={value} checked={checked} {...rest}>
		<Stack
			sx={{
				gap: 150,
			}}
		>
			{isRecommended && <RecommendedChip />}
			<Stack
				sx={{
					gap: 100,
				}}
			>
				<Stack
					direction="row"
					sx={{
						alignItems: 'center',
						gap: 100,
					}}
				>
					{icon}
					<Typography
						variant="title-xs"
						sx={{
							fontWeight: 500,
						}}
					>
						{label}
					</Typography>
				</Stack>
				<Typography
					variant="body-sm"
					sx={({ vars }) => ({ color: vars.palette.uc.text.weak })}
				>
					{description}
				</Typography>
			</Stack>
		</Stack>
	</RadioTile>
);

export default BackupTile;
